import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Button } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import SummarizeIcon from '@mui/icons-material/Summarize';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import GroupIcon from '@mui/icons-material/Group';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BarChartIcon from '@mui/icons-material/BarChart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import SpeedIcon from '@mui/icons-material/Speed';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import branding from '../../styles/branding';

const sidebarItems = [
  { id: 5, icon: <AutoAwesomeIcon style={branding.icon.style} />, text: 'Custom AI Card', subtext: 'Custom AI Analysis, Powered by AI' },
  { id: 1, icon: <SummarizeIcon style={branding.icon.style} />, text: 'Summarize Data', subtext: 'Quick Summaries, Powered by AI' },
  { id: 2, icon: <LightbulbIcon style={branding.icon.style} />, text: 'AI Recommendation', subtext: 'Smart Proposals, Powered by AI' },
  { id: 3, icon: <GroupIcon style={branding.icon.style} />, text: 'Analyze Major Issues', subtext: 'Unlock Complexities, Powered by AI' },
  { id: 4, icon: <EmojiEventsIcon style={branding.icon.style} />, text: 'Success Factors', subtext: 'Success Stories, Powered by AI' },
  { id: 6, icon: <BarChartIcon style={branding.icon.style} />, text: 'Build Bar Chart', subtext: 'Visualize Your Data with Bar' },
  { id: 9, icon: <ShowChartIcon style={branding.icon.style} />, text: 'Build Line Chart', subtext: 'Visualize trends over time' },
  { id: 7, icon: <PieChartIcon style={branding.icon.style} />, text: 'Build Pie Chart', subtext: 'Visualize Your Data with Pie' },
  { id: 8, icon: <SpeedIcon style={branding.icon.style} />, text: 'KPI', subtext: 'Min, Max, Average & more for numerical columns' },
];

const CardsSidebar = ({ onAddButtonClick }) => {
  return (
    <List className="cards-sidebar">
      {sidebarItems.map((item, index) => (
        <ListItem key={item.id} className="cards-sidebar-item">
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText 
            primary={item.text} 
            secondary={item.subtext}
            sx={{
              '& .MuiListItemText-primary': {
                fontSize: '0.75rem',
              },
              '& .MuiListItemText-secondary': {
                fontSize: '0.625rem',
              }
            }}
          />
          {index < 5 && <AutoFixHighIcon style={{ marginLeft: 'auto', marginRight: '0.625rem', fontSize: '0.9375rem', color:'black' }} />}
          <Button 
            variant={branding.button.variant}
            size={branding.button.size}
            sx={branding.button.sx}
            onClick={() => onAddButtonClick(item.id)}
          >
            Add
          </Button>
        </ListItem>
      ))}
    </List>
  );
};

export default CardsSidebar;
